import axiosClient from '../utils/axiosClient';
import config from '../config';

const getGeneralContent = async () => {
  const applicationId = config.APPLICATION_ID;

  try {
    const response = await axiosClient.get(`${config.API_BASE_URL}/content`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export { getGeneralContent };
